
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout/Layout';
import Home from './components/Home/Home';
import Registraction from './components/RegistrationPage/Registraction';
import DashBoard from './components/DashBoard/DashBoard';
import Login from './components/RegistrationPage/Login';
import FetchData from './components/FetchData/FetchData';
import Referral from './components/UserReferral/Referral';
function App() {
  // const router = createBrowserRouter(
  //   createRoutesFromElements(
  //     <Route path='/' element={<Layout />}>
  //       <Route path='/home' element={<Home />} />
  //       <Route path='/register' element={<Registraction />} />
  //       <Route path='/dashboard' element={<DashBoard />} />
  //       <Route path='/' element={<Login />} />
  //       <Route path='/fetch-user' element={<FetchData />} />
  //     </Route>
  //   )
  // )

  return (
    <>
      {/* <RouterProvider router={router} /> */}
      <>
      <BrowserRouter basename='/GainApex'>
        <Routes>
          <Route path='/' element={<Layout />} >
          <Route path='/home' element={<Home />} />
          <Route path='/register' element={<Registraction />} />
          <Route path="/Register/:userReferralCode" element={<Registraction />} />
          <Route path='/dashboard' element={<DashBoard />} />
          <Route path='/' element={<Registraction />} />
          {/* <Route path='/' element={<Login />} /> */}
          <Route path='/fetch-user' element={<FetchData />} />
          </Route>
        <Route path='/referral' element={<Referral/>}/>
        </Routes>
      </BrowserRouter>
    </>
    </>
  );
}

export default App;


// localStorage.setItem('formData', JSON.stringify([...formData, user]));